import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, Package, Calculator, Gift, MoreHorizontal, Truck, Building, ShoppingBag } from 'lucide-react';
import { useDeliveryAvailability } from '../../hooks/useDeliveryAvailability';
import { useSelector } from 'react-redux';
import { getUser } from '../../state/authSlice';
import { getCourierSetting, getIsPartnerLinked } from '../../state/courierSlice';

const MobileNav = () => {
  const location = useLocation();
  const { isDeliveryAvailable } = useDeliveryAvailability();
  const user = useSelector(getUser);
  const courierSettings = useSelector(getCourierSetting);
  const isPartnerLinked = useSelector(getIsPartnerLinked);
  const isShopEnabled = (courierSettings as any)?.isShopEnabled === true;

  const navItems = [{
    name: user?.isCourier ? 'Dashboard' : 'Warehouse',
    path: '/warehouse',
    icon: <Building className="h-5 w-5" />,
    show: user?.isCourier === true && isPartnerLinked
  }, {
    name: 'Packages',
    path: '/packages',
    icon: <Package className="h-5 w-5" />
  }, {
    name: 'Mailbox',
    path: '/mailbox',
    icon: <Mail className="h-5 w-5" />
    // Shown for everyone (see Sidebar): warehouse couriers use it to advise
    // their customers of the shipping-address format.
  }, {
    name: 'Delivery',
    path: '/delivery-request',
    icon: <Truck className="h-5 w-5" />,
    show: isDeliveryAvailable && user?.isCourier !== true
  }, {
    name: 'Calculator',
    path: '/calculator',
    icon: <Calculator className="h-5 w-5" />,
    show: user?.isCourier !== true
  }, {
    name: 'Shop',
    path: '/shop',
    icon: <ShoppingBag className="h-5 w-5" />,
    show: isShopEnabled && user?.isCourier !== true
  }, {
    name: 'Rewards',
    path: '/referrals',
    icon: <Gift className="h-5 w-5" />,
    show: !isShopEnabled && user?.isCourier !== true
  }, {
    name: 'More',
    path: '/more',
    icon: <MoreHorizontal className="h-5 w-5" />
  }];

  // Filter out items that shouldn't be shown
  const visibleNavItems = navItems.filter(item => item.show !== false);

  return <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t dark:border-gray-700 flex justify-between">
      {visibleNavItems.map(item => {
      const isActive = location.pathname === item.path;
      return <Link key={item.path} to={item.path} className={`
              flex flex-col items-center justify-center py-2 flex-1
              ${isActive ? 'text-primary' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}
            `}>
            {item.icon}
            <span className="text-xs mt-1">{item.name}</span>
          </Link>;
    })}
    </div>;
};
export default MobileNav;
